import React from 'react';
import { useSelector } from 'react-redux';
import { selectErrorToastStatus } from 'reducers/misc';

const ErrorToast = () => {
  const errorToastStatus = useSelector(selectErrorToastStatus);
  if (!errorToastStatus.open) return null;
  return (
    <div className={`Toast Error ${errorToastStatus.message ? 'Show' : 'Hide'}`}>
      <p className="Message">{errorToastStatus.message}</p>
    </div>
  );
};

export default ErrorToast;
